module.exports = __webpack_public_path__ + "static/media/F-world.24806d7e.png";